/** Driver tab — yes/no declarations from Preferences › Driver declarations. */
import { useEffect } from "react";
import { useDeclarations, useDeclarationsNotice, DeclarationsList } from "@/components/DeclarationsBlock";

export default function DeclarationsSlot({ values, set }) {
  const list = useDeclarations({ siteId: values.site_id, direction: values.direction });
  const notice = useDeclarationsNotice({ siteId: values.site_id });
  const answers = values.declaration_answers || {};
  // Expose the active list so save-time validation knows what's required.
  // eslint-disable-next-line react-hooks/exhaustive-deps -- `set` is recreated every render; only list changes matter
  useEffect(() => { set("_declarations", list); }, [list]);
  return <DeclarationsList list={list} answers={answers} notice={notice} onChange={(a) => set("declaration_answers", a)} />;
}
